import { useEffect, useState } from "react";
import { Button, getInput } from "../../../../components/ui";
import { VALID_EMAIL_REGEX } from "../../../../util/email";

const TestEmailModalBody = ({
  closeModal,
  isOpen,
  id,
  sendTestEmail,
  loading,
}) => {
  const [testEmails, setTestEmails] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const inputProps = {
    name: "testEmails",
    onChange: e => setTestEmails(e.target.value),
    type: "text",
    value: testEmails,
  };
  const validateEmails = () => {
    const emails = testEmails.split(",");
    const valid = emails.filter(
      email => !email.trim().match(VALID_EMAIL_REGEX),
    );
    return valid;
  };
  const handleTestEmail = () => {
    if (validateEmails().length) {
      return setErrorMessage(validateEmails().join(", "));
    }
    sendTestEmail({
      variables: {
        input: {
          id: +id,
          to: testEmails.split(",")?.map(item => item.trim()),
        },
      },
    });
    setErrorMessage("");
    closeModal();
  };

  useEffect(() => {
    setTestEmails("");
  }, [isOpen]);

  return (
    <div className="mt-4 flex-col">
      {getInput(inputProps)}
      <div className="pt-4 text-sm text-rose-600">
        {errorMessage &&
          `One or more of the emails you provided is invalid. Your test email has not been sent. Invalid Emails: ${errorMessage}`}
      </div>
      <Button
        className="mr-3"
        label={"Cancel"}
        action={"default"}
        onClick={() => {
          closeModal?.();
        }}
      />
      <Button
        className="mt-4"
        label={"Send Test"}
        onClick={handleTestEmail}
        loading={loading}
      />
    </div>
  );
};

export default TestEmailModalBody;
